import { Col, Form, Row } from "reactstrap";
import { Btn, H3, H4, H5 } from "../../../../../../AbstractElements";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { DependentsFormData, DependentsFormErrors } from "../../../FormData";
import TextField from "../../../../../common/TextField";
import { Button } from "reactstrap";
import { useMutationRequestQuery } from "../../../../../../Hooks/useMutationRequestQuery";
import { insertUpdateClientService } from "../../../../../../Services/PublicPageServices";
import { Continue } from "../../../../../../Utils/Constants";
import { useDispatch } from "react-redux";
import { setFormStatus } from "../../../../../../ReduxToolkit/Reducers/FromStatusSlice";
import { setFormsData } from "../../../../../../ReduxToolkit/Reducers/FormDataSlice";
import Dropdown from "../../../../../common/DropDown";
import { updateFormData } from "../../../../../../ReduxToolkit/Reducers/FactFindDataSlice";

export default function Dependents({ activeCallBack, clientId, setClientId, client1formData }: any) {
    const [formData, setFormData] = useState<any>(DependentsFormData);
    const [formErrors, setFormErrors] = useState<any>(DependentsFormErrors);
    const dispatch = useDispatch()

    const { mutate: insertUpdateClient, isPending: isInsertUpdateClientPending } = useMutationRequestQuery(
        'insertUpdateClientService1',
        insertUpdateClientService,
        {
            onSuccess: (data: any) => {
                toast.success("Dependents information submitted successfully.");
                setClientId(data?.data?.generatedClientID)
                dispatch(setFormStatus({ id: '3', status: 3 }));
                activeCallBack(4);
            },
            onError: (error: any) => {
                toast.error("Failed to submit dependents information.");
                console.error(error);
            },
        }
    );

    useEffect(() => {
        dispatch(setFormsData({
            id: '3',
            formData: formData,
        }));
    }, [formData])

    const formatDependentsData = (formData: any) => {
        return {
            clientID: clientId,
            Client1Email: client1formData.email,
            Client1Mobile: client1formData.mobile,
            Client1FirstName: client1formData.firstName,
            Client1LastName: client1formData.lastName,
            client1DateOfBirth: client1formData.dob,
            client1Gender: client1formData.gender,
            clientSurnName: client1formData.firstName,
            dateUpdated: "2025-01-14T04:56:17.173Z",
            dependent1Name: formData.dependentName1,
            dependent1Age: formData.dependentAge1,
            dependent2Name: formData.dependentName2,
            dependent2Age: formData.dependentAge2,
            dependent3Name: formData.dependentName3,
            dependent3Age: formData.dependentAge3,
            dependent4Name: formData.dependentName4,
            dependent4Age: formData.dependentAge4,
            dependent5Name: formData.dependentName5,
            dependent5Age: formData.dependentAge5,
            dependent6Name: formData.dependentName6,
            dependent6Age: formData.dependentAge6,
        };
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        const formattedData = formatDependentsData(formData);
        if (clientId != 0) {
            dispatch(
                updateFormData({
                    formName: "dependents",
                    formData: formattedData,
                })
            );
            insertUpdateClient(formattedData);
        }
    };

    const handleValueChange = (name: string, value: string) => {
        setFormData((prevData: any) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleErrorChange = (name: string, error: boolean) => {
        setFormErrors((prevErrors: any) => ({
            ...prevErrors,
            [name]: error,
        }));
    };

    return (
        <>
            <Form
                style={{
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    padding: '30px',
                    backgroundColor: '#fff',
                }}
                onSubmit={handleSubmit}
            >
                <Row className='g-3'>
                    <Col xs={12} className='mb-4 text-left'>
                        <H3 className='f-w-900 heading-color'>Dependent Details</H3>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col xs={12} className="text-end">
                        <Btn color="primary" style={{ fontSize: '18px' }} className='me-2' onClick={() => activeCallBack(2)}>
                            Previous
                        </Btn>
                        <Button
                            type="button"
                            color="success"
                            onClick={handleSubmit}
                            disabled={isInsertUpdateClientPending}
                            style={{ fontSize: '18px' }}
                        >
                            {isInsertUpdateClientPending ? "Loading . . ." : Continue}
                        </Button>
                    </Col>
                </Row>

                <Row className="mt-4">
                    {/* Dependent Names Column */}
                    <Col xs={12} md={1} className="d-none d-md-block">
                        <H4 className="f-w-700 heading-color">#</H4>
                        <ul className="list-unstyled mt-4">
                            {Array.from({ length: 4 }).map((_, index) => {
                                const dependentIndex = index + 1;
                                return (
                                    <H5 key={dependentIndex} style={{ marginBottom: '2rem', fontSize: '14px' }}>
                                        {dependentIndex}
                                    </H5>
                                );
                            })}
                        </ul>
                    </Col>

                    {/* Dependent Name Inputs Column */}
                    <Col xs={12} md={3}>
                        <H4 className="f-w-700 text-left heading-color">Dependent Name</H4>
                        <div className="mt-3">
                            {Array.from({ length: 4 }).map((_, index) => {
                                const dependentIndex = index + 1;
                                const tabIndexValue = 1 + index * 2;
                                return (
                                    <div key={dependentIndex} className="mb-3">
                                        <TextField
                                            type="text"
                                            name={`dependentName${dependentIndex}`}
                                            value={formData[`dependentName${dependentIndex}`]}
                                            setValue={handleValueChange}
                                            maxChars={15}
                                            tabIndex={tabIndexValue}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </Col>
                    {/* Dependent Age Inputs Column */}
                    <Col xs={12} md={2}>
                        <H4 className="f-w-700 text-left heading-color">Age</H4>
                        <div className="mt-3">
                            {Array.from({ length: 4 }).map((_, index) => {
                                const dependentIndex = index + 1;
                                const tabIndexValue = 2 + index * 2; // This will give 2, 4, 6, 8 for each field
                                return (
                                    <div key={dependentIndex} className="mb-3">
                                        {/* <TextField
                                            type="number"
                                            name={`dependentAge${dependentIndex}`}
                                            value={formData[`dependentAge${dependentIndex}`]}
                                            setValue={handleValueChange}
                                            maxChars={2}
                                            tabIndex={tabIndexValue} // Set different tabIndex values
                                        /> */}
                                        <Dropdown
                                            label=""
                                            name={`dependentAge${dependentIndex}`}
                                            value={formData[`dependentAge${dependentIndex}`]}
                                            setValue={handleValueChange}
                                            options={Array.from({ length: 17 }, (_, index) => (index + 1).toString())}  // Generates values from 1 to 17
                                            // passCol="col-4"
                                            tabIndex={tabIndexValue}  // Set different tabIndex values
                                            design="flex"
                                        />

                                    </div>
                                );
                            })}
                        </div>
                    </Col>

                </Row>

             
            </Form>
        </>
    );
}
